import { Component } from '@angular/core'

@Component({
    selector: 'app-lg-user-not-authenticated',
    templateUrl: './user-not-authenticated.component.html',
    styleUrls: ['./user-not-authenticated.component.scss'],
    standalone: true,
})
export class UserNotAuthenticatedComponent {}
